interface CheckProps {
  className?: string;
  fill: string;
}

export const CheckFilled = ({ className, fill }: CheckProps) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="#FFFFFF"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 0C6.72843 0 0 6.72843 0 15C0 23.2716 6.72843 30 15 30C23.2716 30 30 23.2716 30 15C30 6.72843 23.2716 0 15 0ZM23.4919 10.7851C23.6365 10.9298 23.7089 11.1002 23.7089 11.2965C23.7089 11.4928 23.6365 11.6632 23.4919 11.8079L13.0477 22.1591C12.9031 22.3037 12.7326 22.376 12.5363 22.376C12.3401 22.376 12.1696 22.3037 12.025 22.1591L6.50845 16.6116C6.36382 16.4669 6.2915 16.2965 6.2915 16.1002C6.2915 15.9039 6.36382 15.7335 6.50845 15.5888L7.90307 14.2252C8.0477 14.0806 8.21816 14.0083 8.41444 14.0083C8.61072 14.0083 8.78117 14.0806 8.9258 14.2252L12.5518 17.8822L21.1056 9.3905C21.2502 9.24587 21.4206 9.17355 21.6169 9.17355C21.8132 9.17355 21.9837 9.24587 22.1283 9.3905L23.4919 10.7851Z"
      fill={fill}
    />
  </svg>
);
